module.exports = __webpack_public_path__ + "img/PurchaseOrRenewLink.a52610d2.jpg";